import qr from '@vkontakte/vk-qr';
import PropTypes from 'prop-types';
import './QrCodeComponent.css';

const QrCodeComponent = ({text, size = 256, className = 'qr-code-class'}) => {
  const options = {
    isShowLogo: false,
    isShowBackground: false,
    foregroundColor: '',
  };
  const code = qr.createQR(text, size, className, options);

  return (<div
    dangerouslySetInnerHTML={{__html: code}}
  ></div>);
}

export default QrCodeComponent;

QrCodeComponent.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
};
